import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';
import { BaseInsightRequest } from 'app/models/partner/base-insight-request.model';
import { GetMostPopularProductsResponse } from 'app/models/partner/response-insight.model';
import { GetSlowestMovingProductsResponse } from 'app/models/partner/response-insight.model';
import { GetMostPopularCombinationsResponse } from 'app/models/partner/response-insight.model';

@Injectable({
  providedIn: 'root'
})
export class PartnerInsightService {
  constructor(private apiHttp: ApiHttp) {}
  public getMostPopularProducts(
    data: BaseInsightRequest,
    messageService: MessageService
  ): Promise<GetMostPopularProductsResponse> {
    return this.apiHttp.post(
      'api/AdminPartnerInsight/GetMostPopularProducts',
      data,
      messageService
    );
  }
  public getSlowestMovingProducts(
    data: BaseInsightRequest,
    messageService: MessageService
  ): Promise<GetSlowestMovingProductsResponse> {
    return this.apiHttp.post(
      'api/AdminPartnerInsight/GetSlowestMovingProducts',
      data,
      messageService
    );
  }
  public getMostPopularCombinations(
    data: BaseInsightRequest,
    messageService: MessageService
  ): Promise<GetMostPopularCombinationsResponse> {
    return this.apiHttp.post(
      'api/AdminPartnerInsight/GetMostPopularCombinations',
      data,
      messageService
    );
  }

  public exportInsightsReport(data: any, messageService: MessageService): Promise<any> {
    return this.apiHttp.postDownloadFile('api/AdminPartnerInsight/ExportInsightsReport', data, messageService);
  }
}
